import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  InputGroup,
  Label,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import { HiFunnel } from "react-icons/hi2";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import TableContainerV1 from "components/Common/TableContainerV1";

import { getPlantWiseSalesReport, getAllRegion } from "../../../helpers/UAM/report.helper"

import * as XLSX from 'xlsx';
import { formatNumberWithCommas } from "common/utility";
import "../report.scss";

const PlantWiseSalesReport = props => {

  //meta title
  document.title = "Plant Wise Sales Report | DMS";

  const [PlantWiseSalesReport, setPlantWiseSalesReport] = useState([]);

  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0, })
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("zone");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("asc");
  const [filters, setFilters] = useState(null);
  const [filters2, setFilters2] = useState(null);
  const [sortingOptions, setSortingOptions] = useState({ column: "", isAsc: true, optionalColumn: ['zone', 'plant', 'order', 'sale'], });
  const [showFilter, setShowFilter] = useState(false);
  const [totalData, setTotalData] = useState('');
  const flatpickrRef = useRef(null);
  const flatpickrRef2 = useRef(null);
  const [regionList, setRegionList] = useState([])
  const [selectedState, setSelectedState] = useState('')
  // Customber Column
  const columns = useMemo(
    () => [

      {
        Header: 'Zone',
        accessor: 'zone',
        filterable: true,
        Cell: (cellProps) => {
          const { zone } = cellProps.row.original;
          if (zone == 'Grand Total') {
            return cellProps.value ? <b className="font-size-14">{cellProps.value}</b> : "";
          } else {
            return cellProps.value ? cellProps.value : "";
          }
        }
      },
      {
        Header: 'Plant',
        accessor: 'plant',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
          ;
        }
      },
      {
        Header: 'Order',
        accessor: 'order',
        filterable: true,
        Cell: (cellProps) => {
          const { zone } = cellProps.row.original;
          if (zone == 'Grand Total') {
            return cellProps.value ? <b className="font-size-14">{formatNumberWithCommas(cellProps.value)}</b> : "";
          } else {
            return cellProps.value ? formatNumberWithCommas(cellProps.value) : "";
          }
        }
      },
      {
        Header: 'Sale',
        accessor: 'sale',
        filterable: true,
        Cell: (cellProps) => {
          const { zone } = cellProps.row.original;
          if (zone == 'Grand Total') {
            return cellProps.value ? <b className="font-size-14">{formatNumberWithCommas(cellProps.value)}</b> : "";
          } else {
            return cellProps.value ? formatNumberWithCommas(cellProps.value) : "";
          }
        }
      },
    ],
  );

  useEffect(() => {
    fetchPlantWiseSalesReport({})
    fetchAllRegion()
  }, [])

  const fetchPlantWiseSalesReport = (data) => {
    getPlantWiseSalesReport(data)
      .then((response) => {
        if (response.status && response.code == 200) {
          setPlantWiseSalesReport(response.data.data)
          setTotalData(calculateZoneTotals(response.data.data))
          const { totalItems, totalPages, currentPage } = response.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ totalRecords: 0 })
          setPlantWiseSalesReport([])
        }

      })
      .catch((err) => { console.log(err) })
  }

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus, filter = filters, filter2 = filters2, zone = selectedState) => {
    setPageSize(pageSize);
    setCurrentPage(page)
    fetchPlantWiseSalesReport({ page, limit: pageSize, searchKey, columnName, sortingOrder, deliveryDate: filter, invoiceDate: filter2, zone })
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = 'asc';
    setSortingOrderStatus(sortingOrder);
    handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder, filters, filters2);
  };

  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);
  };

  const handleDateFilter = () => {
    handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, filters, filters2, selectedState)
    setShowFilter(false)
  }

  const handleClearSearch = () => {
    setSearchValue("");
    setFilters(null)
    setFilters2(null)
    setSelectedState('')
    if (flatpickrRef && flatpickrRef.current) {
      flatpickrRef.current.flatpickr.clear();
    }
    if (flatpickrRef2 && flatpickrRef2.current) {
      flatpickrRef2.current.flatpickr.clear();
    }
    handlePageChange(1, pageSize, "", 'zone', 'asc', null, null, null, '');
  };

  const handleClearFilters = () => {
    setFilters(null)
    setFilters2(null)
    setSelectedState('')
    setShowFilter(false)
    if (flatpickrRef && flatpickrRef.current) {
      flatpickrRef.current.flatpickr.clear();
    }
    if (flatpickrRef2 && flatpickrRef2.current) {
      flatpickrRef2.current.flatpickr.clear();
    }
    handlePageChange(1, pageSize, searchValue, 'zone', 'asc', null, null, null, '');
  };

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setFilters({
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }
  };

  const handleDateChange2 = (selectedDates) => {
    if (selectedDates.length === 2) {
      setFilters2({
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }
  };

  const downloadExcel = () => {
    let dataWithModifiedCol = PlantWiseSalesReport.map(report => {
      let newReport = {
        "Zone": report.zone,
        "Plant": report.plant,
        "Order": formatNumberWithCommas(report.order),
        "Sale": formatNumberWithCommas(report.sale),
      }
      return newReport
    })
    const totalOrder = PlantWiseSalesReport.reduce((sum, report) => sum + report.order, 0);
    const totalSale = PlantWiseSalesReport.reduce((sum, report) => sum + report.sale, 0);

    dataWithModifiedCol.push({
      "Zone": "Total",
      "Order": formatNumberWithCommas(totalOrder),
      "Sale": formatNumberWithCommas(totalSale),
    });
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    const sheetData = XLSX.utils.json_to_sheet(dataWithModifiedCol);
    // Add the sheet to the workbook
    XLSX.utils.book_append_sheet(workbook, sheetData, 'PlantWiseSalesReport');
    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'Plant_Wise_Sales_Report.xlsx');
  };

  const toggleFilter = () => {
    setShowFilter(!showFilter)
  }

  const customeFilterSection = (
    <div>
      <div className="text-md-end">
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-2"
          onClick={toggleFilter}
        >
          <HiFunnel style={{ fontSize: '1rem' }} />
        </Button>

      </div>
      {showFilter && (
        <div className="filter-container2" style={{ minHeight: '50px' }}>
          <div className="mb-1 d-flex justify-content-between align-items-center text-center">
            <h5 style={{ margin: 0 }}>Filter</h5>
            <button
              type="button"
              onClick={() => setShowFilter(false)}
              style={{
                border: 'none',
                background: 'transparent',
                fontSize: '1.2rem',
                cursor: 'pointer',
              }}
            >
              ×
            </button>
          </div>
          {/* <div>
            <Label>Delivery Date: </Label>
            <InputGroup style={{ minWidth: '250px' }}>
              <Flatpickr
                ref={flatpickrRef}
                className="form-control"
                placeholder="Start Date - End Date"
                options={{
                  mode: 'range',
                  dateFormat: 'd-m-Y'
                }}
                value={filters?.startDate && filters?.endDate ? [filters?.startDate, filters?.endDate] : []}
                onChange={handleDateChange}
              />
            </InputGroup>
          </div> */}
          <div className="mt-2">
            <Label>Delivery Date: </Label>
            <InputGroup style={{ minWidth: '250px' }}>
              <Flatpickr
                ref={flatpickrRef2}
                className="form-control"
                placeholder="Start Date - End Date"
                options={{
                  mode: 'range',
                  dateFormat: 'd-m-Y'
                }}
                value={filters2?.startDate && filters2?.endDate ? [filters2?.startDate, filters2?.endDate] : []}
                onChange={handleDateChange2}
              />
            </InputGroup>
          </div>
          <div className="mt-2">
            <Label>Select Zone: </Label>
            <Select
              type="select"
              placeholder='Zone'
              options={regionList.map((option) => ({
                label: option.zone,
                value: option.zone,
              }))}
              name="state"
              id="state"
              onChange={(selectedOption) => {
                setSelectedState(selectedOption);
              }}
              value={selectedState}
            />
          </div>
          <div className="d-flex flex-row justify-content-end gap-2 mt-3">
            <Button
              type="button"
              color="light"
              className="btn-rounded"
              onClick={handleClearFilters}
            >
              Clear
            </Button>
            <Button
              type="button"
              color="success"
              className="btn-rounded"
              onClick={handleDateFilter}
            >
              Apply
            </Button>
          </div>
        </div>
      )}
    </div>
  );

  const buttonSection = (
    <div className="text-sm-end">

      {PlantWiseSalesReport.length > 0 && (<Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={downloadExcel}
      >
        <i className="bx bx-archive-in me-1" />
        {'Download'}
      </Button>)}

    </div>);

  const calculateZoneTotals = (data) => {
    let totalOrder = 0;
    let totalSale = 0;

    data.forEach(item => {
      totalOrder += item.order || 0;
      totalSale += item.sale || 0;
    });
    return (<tr>
      <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{'Total'}</td>
      <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
      <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{formatNumberWithCommas(totalOrder)}</td>
      <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{formatNumberWithCommas(totalSale)}</td>
    </tr>)
  };

  const fetchAllRegion = () => {
    getAllRegion()
      .then((response) => {
        if (response.status && response.code == 200) {
          setRegionList(response.data || [])
        } else {
          setRegionList([])
        }
      })
      .catch((err) => { console.log(err) })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Reports" breadcrumbItem="Plant Wise Sales Report" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={PlantWiseSalesReport}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  searchHelperText="Search by Zone, Plant"
                  handleSearchFilter={handleSearchFilter}
                  customFilterSection={customeFilterSection}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  isTotal={true}
                  TotalData={totalData}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PlantWiseSalesReport;
